enum TipoPensionEnum {
    RetiroProgramado = '3',
    RentaVitalicia = '4'
}

export default TipoPensionEnum;